import React from 'react';
import useLocalization from '../../hooks/useLocalization';
import { TableCell, TableRow } from '../ui/table';
import useAppChoices from '../../hooks/useAppChoices';

const SectionRow = ({ sectionName, span, isRtlLanguage, type }) => {
  const { langCode, translate } = useLocalization();
  const category = useAppChoices('category').find(c => c.key === sectionName && c?.calcType === type);

  return (
    <TableRow
      className={`bg-primary border-0 px-3 text-white text-${isRtlLanguage ? 'end' : 'start'} no-pointer-events`}
    >
      <TableCell className="ps-4 py-2 text-white font-bold">
        {category?.[langCode?.toLowerCase() || 'english'] || translate(sectionName)}
      </TableCell>
      <TableCell className="p-2 bg-primary" colSpan={span - 1}></TableCell>
    </TableRow>
  );
};

export default SectionRow;
